import { useTheme } from '@mui/material/styles';
import { grey } from '@mui/material/colors';


export const HealthBenefitsStyles = () => {
    const theme = useTheme();
    return {
        "& .toggle_button": {
            padding: "14px",
            border: "none",
            textTransform: "uppercase",
            borderRadius: "8px",
            background: theme.palette.purpleCold.dark,
            color: "#fff",
            width: "100%"
        },
        "& .filter_text": {
            padding: "10px",
            textAlign: "center",
            width: "100%",
            fontWeight: "bold",
            margin: "0 auto"
        },
        "& .nulls-block": {
            fontSize: "12px",
            padding: "18px",
        },
        "& .nulls-block__districts": {
            paddingLeft: 0,
            margin: "6px 0",
            "& > li": {
                display: "inline-flex",
                alignItems: "center",
                marginRight: "14px",
                width: {
                    xs: "100%",
                    sm: "calc(50% - 16px)",
                    md: "auto"
                }
            },
            "& > li:before": {
                background: `${grey[700]}`,
                borderRadius: "50%",
                content: '""',
                display: "block",
                height: "4px",
                marginRight: "4px",
                width: '4px',
            }
        },
        "& .toggle-container": {
            display: "flex",
            justifyContent: "flex-start",
            padding: "10px",
            flexDirection: {
                xs: "column",
                md: "row"
            }
          },
          
          "& .toggle-group": {
            display: "flex",
            alignItems: "center",
            margin: {
                xs: "10px",
                md: "0 20px 0 0",
            }
          },

         "& .toggle-group > span": {
            marginRight: "5px"
          }
    }
}